import { useNavigate, useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Checkbox,
  Chip,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { deleteSpaces } from "app/utils";
import { useCorreosElectronicosContext } from "../correos-electronicos-context";
import {
  CorreoElectronicoProvider,
  useCorreoElectronicoContext,
} from "./correo-electronico-context";
import { correoElectronicoRegex } from "app/utils/regexps";
import { MdArrowBack } from "react-icons/md";

export function CorreoElectronicoForm() {
  return (
    <CorreoElectronicoProvider>
      <Form />
    </CorreoElectronicoProvider>
  );
}

function Form() {
  const params = useParams();
  const navigate = useNavigate();

  const {
    addCorreoElectronico,
    isAdding,
    updateCorreoElectronico,
    isUpdating,
    cancel,
  } = useCorreosElectronicosContext();

  const { correoElectronico, setCorreoElectronico, isEditing } =
    useCorreoElectronicoContext();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!isEditing) {
        return await updateCorreoElectronico({
          correoElectronicoId: params.correo_electronico_id,
          correoElectronico,
        });
      } else {
        return await addCorreoElectronico({ correoElectronico });
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  return (
    <Container maxWidth="sm" className="animate__animated animate__fadeIn">
      <Paper
        component="form"
        onSubmit={handleSubmit}
        onReset={cancel}
        sx={{ padding: 2 }}
        variant="outlined"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <Tooltip title="Atrás">
                  <IconButton
                    onClick={() => navigate("../..", { replace: true })}
                  >
                    <MdArrowBack />
                  </IconButton>
                </Tooltip>

                <Typography variant="h6">
                  {`${
                    !!isEditing ? "Editar" : "Agregar"
                  } dirección de correo electrónico`}
                </Typography>
              </Stack>

              {!!isEditing && (
                <Chip
                  label={
                    !!correoElectronico.correo_electronico_verificado
                      ? "Verificado"
                      : "Pendiente"
                  }
                  color={
                    !!correoElectronico.correo_electronico_verificado
                      ? "success"
                      : "warning"
                  }
                  size="small"
                  variant="outlined"
                />
              )}
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="email"
              label="Dirección de correo electrónico"
              value={correoElectronico.correo_electronico_direccion}
              onChange={(e) =>
                setCorreoElectronico((correo) => ({
                  ...correo,
                  correo_electronico_direccion: deleteSpaces(e.target.value),
                }))
              }
              inputProps={{
                pattern: correoElectronicoRegex.pattern,
                title: correoElectronicoRegex.title,
              }}
              size="small"
              fullWidth
              required
              disabled={!!correoElectronico.correo_electronico_verificado}
            />
          </Grid>

          <Grid item xs={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={correoElectronico.correo_electronico_principal}
                    onChange={(e) =>
                      setCorreoElectronico((correo) => ({
                        ...correo,
                        correo_electronico_principal: e.target.checked,
                      }))
                    }
                  />
                }
                label="¿Es una dirección de correo electrónico principal?"
                disabled={!!correoElectronico.correo_electronico_verificado}
              />
            </FormGroup>
          </Grid>

          {!correoElectronico.correo_electronico_verificado && (
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="end" spacing={1}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  size="small"
                  color={!!isEditing ? "warning" : "success"}
                  loading={!!isUpdating || !!isAdding}
                >
                  {!!isEditing ? "Actualizar" : "Agregar"}
                </LoadingButton>

                <Button
                  type="reset"
                  variant="outlined"
                  size="small"
                  color="inherit"
                  disabled={!!isUpdating || !!isAdding}
                >
                  Cancelar
                </Button>
              </Stack>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Container>
  );
}
